module.exports = __webpack_public_path__ + "prod/1.42.2/img/paySuccess-pc.ba3bb1d9.svg";